<ng-template #diffModal>
  <div class="task-log-diff-modal">
    <div class="task-log-diff-modal__header">
      <div>
        <div class="task-log-diff-modal__title" i18n>Historique</div>
        <div class="task-log-diff-modal__subtitle">
          {{ statusLabel }} - {{ displayDate }} -
          <ng-container i18n>Par</ng-container> {{ displayName }}
        </div>
      </div>
      <button
        class="lty-btn lty-btn-white"
        type="button"
        (click)="closeModal()"
        i18n
      >
        Fermer
      </button>
    </div>

    @if (currentData) {
      <div class="task-log-diff-modal__body">
        @if (currentData.currentElement.leadSnapshot) {
          <app-task-log-lead-diff
            [currentSnapshot]="currentData.leadBaseline"
            [baselineSnapshot]="currentData.currentElement.leadSnapshot"
          />
        }

        @if (currentData.currentElement.proposalSnapshot) {
          <app-task-log-proposal-diff
            [currentSnapshot]="displayedProposalSnapshot"
            [baselineSnapshot]="proposalSnapshotBaseline"
            [compare]="compareProposalSnapshot"
          />
        }
      </div>
    }
  </div>
</ng-template>
